import { render, staticRenderFns } from "./PurchaseHubQuotationShare.vue?vue&type=template&id=6003e754&scoped=true&lang=pug&"
import script from "./PurchaseHubQuotationShare.vue?vue&type=script&lang=js&"
export * from "./PurchaseHubQuotationShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6003e754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
